import Marquee3k from 'marquee3000';

window.addEventListener('DOMContentLoaded', () => {
    Marquee3k.init();
});